import { Pipe, PipeTransform, Inject, LOCALE_ID } from '@angular/core';
import { formatDate } from '@angular/common';

@Pipe({
    name: 'customShortDate',
    standalone: false
})
export class CustomShortDatePipe implements PipeTransform {
    constructor(@Inject(LOCALE_ID) private locale: string) {}

    transform(value: Date | string | number): string {
        let format = 'shortDate';
        if (this.locale.startsWith('de')) {
            format = 'dd.MM.yyyy';
        }
        return formatDate(value, format, this.locale);
    }
}
